import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@libs/store/auth';
import { clearUserLocalData } from '@libs/localStorage';

export function AuthGuard({ children }: PropsWithChildren) {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated()) {
    clearUserLocalData();
    return <Navigate to="/login" />;
  }

  return children;
}
